import axios from 'axios';
import moment from 'moment';
import router from './router';
import { error, session_error } from './components/ErrorDialog.vue';

function to_mysql(date)
{
    if (date == null || date == '') {
	return null;
    }
    return moment(date).format('YYYY-MM-DD HH:mm:ss')
}

function check_session(response)
{
    if (response.data.auth_error) {
	session_error();
    }
    if (response.data.result == 'error') {
	error(response.data.message);
	throw new Error(response.data.message);
    }
    return response;
}

export async function checkMaintenance(opt)
{
    let res = await axios.post('/checkMaintenance.php', {});
    if (opt && opt.check_only) {
	return res.data;
    }
    if (res.data.maintenance) {
	router.push({name: 'Maintenance'});
    }
}

export async function doLogin(user, pass)
{
    let response = await axios.post('/login.php', {user, pass});
    return response.data;
}

export async function getProductList(opts)
{
    let response = check_session(await axios.post('/getProductList.php',opts));
    return response.data;
}

export async function addProduct(product)
{
    let data = {
	product_name: product.product_name,
	software_code: product.software_code,
	target_os: product.target_os,
	sale_start_date: to_mysql(product.sale_start_date),
	sale_end_date: to_mysql(product.sale_end_date)
    };
    return check_session(await axios.post('/addProduct.php', data));
}

export async function updateProduct(product)
{
    let data = {
	product_id: product.product_id,
	product_name: product.product_name,
	software_code: product.software_code,
	target_os: product.target_os,
	sale_start_date: to_mysql(product.sale_start_date),
	sale_end_date: to_mysql(product.sale_end_date)
    };
    return check_session(await axios.post('/updateProduct.php', data));
}

export async function deleteProduct(product, opts)
{
    return check_session(await axios.post('/deleteProduct.php', product));
}

export async function getVersionInfo(opts)
{
    let response = check_session(await axios.post('/getVersionInfo.php',opts));
    return response.data;
}

export async function addVersionInfo(versionInfo, opts)
{
    let data = {
	software_code: versionInfo.software_code,
	target_os: versionInfo.target_os,
	latest_version: versionInfo.latest_version,
	default_download_url: versionInfo.default_download_url,
	japanese_download_url: versionInfo.japanese_download_url,
	release_date: to_mysql(versionInfo.release_date),
	release_note: versionInfo.release_note
    };
    return check_session(await axios.post('/addVersionInfo.php', data));
}

export async function updateVersionInfo(versionInfo, opts)
{
    let data = {
	software_code: versionInfo.software_code,
	target_os: versionInfo.target_os,
	latest_version: versionInfo.latest_version,
	default_download_url: versionInfo.default_download_url,
	japanese_download_url: versionInfo.japanese_download_url,
	release_date: to_mysql(versionInfo.release_date),
	release_note: versionInfo.release_note,
	id: versionInfo.id
    };
    return check_session(await axios.post('/updateVersionInfo.php', data));
}

export async function deleteVersionInfo(versionInfo, opts)
{
    return check_session(await axios.post('/deleteVersionInfo.php', versionInfo));
}

export async function getLicenseTypeList()
{
    let response = check_session(await axios.post('/getLicenseTypeList.php'));
    return response.data;
}

export async function getSoftwareTypeList()
{
    let response = check_session(await axios.post('/getSoftwareTypeList.php'));
    return response.data;
}

export async function getTargetOSList(with_all)
{
    let response = check_session(await axios.post('/getTargetOSList.php',{all:with_all}));
    return response.data;
}

export async function getActivationCodeList(opts)
{
    let response = check_session(await axios.post('/getActivationCodeList.php',opts));
    return response.data;
}

export async function generateActivationCode(product_id, count)
{
    let response = check_session(await axios.post('/generateActivationCode.php',{product_id,count}));
    return response.data;
}

export function downloadActivationCode(name, file)
{
    let element = document.createElement('a');
    element.href = `/downloadActivationCode.php?name=${name}`;
    element.download = file;
    element.target = '_blank';
    element.click();
}

export async function checkVersion(software_type, target_os)
{
    let opts = {
	software_code: software_type,
	target_os: target_os
    };
    let response = check_session(await axios.post('/checkVersionInfo.php',opts));
    return response.data;
}

export async function searchActivationCode(data, opts)
{
    let params = Object.assign({}, data, opts);
    let response = check_session(await axios.post('/searchActivationCode.php',params));
    return response.data;
}

export async function getActivationHistory(data, opts)
{
    let params = Object.assign({}, data, opts);
    let response = check_session(await axios.post('/getActivationHistory.php',params));
    return response.data;
}

export async function updateMaxInstallCount(activation_code, maximum_install_count)
{
    let params = {
	activation_code,
	maximum_install_count
    }
    check_session(await axios.post('/updateActivationCode.php', params));
}

export async function getFirmwareInfo(data)
{
    let response = check_session(await axios.post('/getFirmwareInfo.php',data));
    return response.data;
}

export async function getFirmwareList(opts)
{
    let response = check_session(await axios.post('/getFirmwareList.php',opts));
    return response.data;
}

export async function addFirmwareInfo(firmware, opts)
{
    let data = {
	model_id:        firmware.model_id,
	status:          firmware.status,
	latest_version:  firmware.latest_version,
	ja_download_web: firmware.ja_download_web,
	en_download_web: firmware.en_download_web,
	file_id:         firmware.file_id,
	release_date:    to_mysql(firmware.release_date),
	release_note:    firmware.release_note,
	session_id:      firmware.session_id
    };
    return check_session(await axios.post('/addFirmwareInfo.php', data));
}

export async function updateFirmwareInfo(firmware, opts)
{
    let data = {
	model_id:        firmware.model_id,
	status:          firmware.status,
	latest_version:  firmware.latest_version,
	ja_download_web: firmware.ja_download_web,
	en_download_web: firmware.en_download_web,
	file_id:         firmware.file_id,
	release_date:    to_mysql(firmware.release_date),
	release_note:    firmware.release_note,
	session_id:      firmware.session_id,
	firmware_id:     firmware.firmware_id
    };
    return check_session(await axios.post('/updateFirmwareInfo.php', data));
}

export async function deleteFirmwareInfo(session_id, firmware_id)
{
    return check_session(await axios.post('/deleteFirmwareInfo.php', {session_id, firmware_id}));
}

export async function getModelList(del_flg,opts)
{
    let response = check_session(await axios.post('/getModelList.php',Object.assign({del_flg},opts)));
    return response.data;
}

export async function addModel(model)
{
    let data = {
	model_name: model.model_name,
    del_flg: model.del_flg
    };
    return check_session(await axios.post('/addModel.php', data));
}

export async function updateModel(model)
{
    let data = {
	model_id: model.model_id,
    del_flg: model.del_flg,
	model_name: model.model_name
    };
    return check_session(await axios.post('/updateModel.php', data));
}

export async function deleteModel(model, opts)
{
    return check_session(await axios.post('/deleteModel.php', model));
}


export async function uploadFirmware(session_id,model_id,latest_version,file)
{
    var params = new FormData();
    params.append('session_id', session_id);
    params.append('model_id', model_id);
    params.append('latest_version',latest_version);
    params.append('file', file);
    return await axios.post('/uploadFirmware.php', params);
}

export async function createSession()
{
    return await axios.post('/createSession.php', {});
}

export async function updateSession(session_id)
{
    return await axios.post('/updateSession.php', {session_id});
}

export async function releaseFirmware(firmware_id)
{
    return await axios.post('/releaseFirmware.php', {firmware_id});
}

export async function removeFirmware(session_id,file_id,firmware_id)
{
    return await axios.post('/removeFirmware.php', {session_id,file_id,firmware_id});
}

export async function wait(t)
{
    return new Promise((resolve) => {
	setTimeout( () => {
	    resolve();
	}, t*1000);
    });
}
